import crews from "csi/access/crews";
import Action from "csi/def/Action";
import Request from "csi/def/Request";
import reflection from "csi/reflection";
import TableWidget from "csi/table/Widget";
import declare from "dojo/_base/declare";
import PluginFactory from "csi/view/PluginFactory";
import ToolbarPluginMenu from "csi/view/ToolbarPluginMenu";
import { Context } from "csi/def/Context";

const CANVAS_TEMPLATE = "CanvasTemplate";
const CANVAS_TEMPLATE_EXPORT_PLUGIN_NAME = "tableCanvasImport";
const CANVAS_TEMPLATE_IMPORT_PLUGIN_NAME = "tableCanvasExport";
const PRODUCT_SPEC_LIB_ADMIN = "Product Specification Library Administrator";

PluginFactory.declare(CANVAS_TEMPLATE_EXPORT_PLUGIN_NAME, ToolbarPluginMenu, {
	constructor: function() {
		const rcCanvasTemplate = reflection.getClass(CANVAS_TEMPLATE);
		this.defAction = Object.assign(new Action(), {
			classController: "csi/datasheet/ExportCanvasTemplatesController",
			m_id: "ExportCanvasTemplates",
			m_rcTarget: rcCanvasTemplate,
			m_request: Object.assign(new Request(), {
				m_module: "SiteAdmin",
				m_operation: "ExportCanvasTemplates",
			}),
		});
		this.defAction.resolve();
	},
	/** Action is only available for Product Specification Library Administrator. */
	validatePlugin: function(ctx: Context): boolean {
		return crews.isInRoles([PRODUCT_SPEC_LIB_ADMIN], ctx.getContextNode());
	},
});

PluginFactory.declare(CANVAS_TEMPLATE_IMPORT_PLUGIN_NAME, ToolbarPluginMenu, {
	constructor: function() {
		const rcCanvasTemplate = reflection.getClass(CANVAS_TEMPLATE);
		this.defAction = Object.assign(new Action(), {
			bKeepViewEnabled: true,
			classController: "csi/datasheet/ImportCanvasTemplatesController",
			m_id: "ImportCanvasTemplates",
			m_postAction: "postActionRefresh",
			m_rcTarget: rcCanvasTemplate,
		});
		this.defAction.resolve();
	},
	/** Action is only available for Product Specification Library Administrator. */
	validatePlugin: function(ctx: Context): boolean {
		return crews.isInRoles([PRODUCT_SPEC_LIB_ADMIN], ctx.getContextNode());
	},
});

const CanvasTemplateTable = declare(TableWidget, {
	plugins: [
		"fullScreen",
		"print",
		{
			name: "Export",
			showLabel: false,
			icon: "csiActionIcon iconExport",
			children: [
				"tableExcel",
				"tableExcelFlat",
				"tableExcelSwitchboard",
				"pdf",
				CANVAS_TEMPLATE_IMPORT_PLUGIN_NAME,
				CANVAS_TEMPLATE_EXPORT_PLUGIN_NAME,
			],
		},
		"tableExpand",
		"tableCollapse",
		"columns",
		"charts",
		"tableRemoveSort",
		"tableApplySort",
		"refresh",
		"|",
		"pageSize",
		"|",
		"tableSuspend",
		"filter",
	],
});

export = CanvasTemplateTable